import { render, staticRenderFns } from "./provisao-aprovar.vue?vue&type=template&id=1abc2654&scoped=true"
import script from "./provisao-aprovar.vue?vue&type=script&lang=ts"
export * from "./provisao-aprovar.vue?vue&type=script&lang=ts"
import style0 from "./provisao-aprovar.vue?vue&type=style&index=0&id=1abc2654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abc2654",
  null
  
)

export default component.exports